import {
  getApiV1ThreeLetterCodePartnerAdminsTopBanners,
  getGetApiV1ThreeLetterCodePartnerAdminsTopBannersKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsTopBanners200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';
import { KeyedMutator } from 'swr';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
};

type ReturnType = {
  /** トップバナー一覧データ */
  data: GetApiV1ThreeLetterCodePartnerAdminsTopBanners200;
  /** データ再取得用のmutate関数 */
  mutate: KeyedMutator<GetApiV1ThreeLetterCodePartnerAdminsTopBanners200>;
};

/**
 * useGetPartnerAdminsTopBannersフックの型定義
 */
type IUseGetPartnerAdminsTopBanners = (args: Args) => ReturnType;

/**
 * パートナー管理者用トップバナー一覧取得フック
 * Suspenseを使用してデータを取得
 */
export const useGetPartnerAdminsTopBanners: IUseGetPartnerAdminsTopBanners = ({
  threeLetterCode,
}) => {
  const { data, mutate } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsTopBannersKey(threeLetterCode),
    () => getApiV1ThreeLetterCodePartnerAdminsTopBanners(threeLetterCode),
    { suspense: true }
  );

  return {
    data,
    mutate,
  };
};
